import React from 'react'
import PropTypes from 'prop-types'

import { Tabbed } from 'mailup-web-components'

export const Tabs = ({ onChange, tabs, defaultActive }) => {
  return (
    <Tabbed onChange={onChange} tabs={tabs} defaultActive={defaultActive} />
  )
}

Tabs.defaultProps = {
  onChange: () => null
}

Tabs.propTypes = {
  onChange: PropTypes.func,

  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      className: PropTypes.string,
      disabled: PropTypes.bool,
      id: PropTypes.string,
      label: PropTypes.string,
      onClick: PropTypes.func,
      content: PropTypes.element
    })
  ),

  defaultActive: (props, propName, componentName) => {
    const isValid = props.tabs
      .map(({ value }) => value)
      .includes(props[propName])
    if (!isValid) {
      return new Error(
        `Invalid prop \`${propName}\` supplied to
        \`${componentName}\`. Prop value must correspond to
        an \`id\` present in of \`props.tabs\` values.`
      )
    }
  }
}
